var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-select',{attrs:{"options":_vm.availableOptions,"filter":_vm.availableOptions.length > 10,"placeholder":_vm.placeHolderText,"aria-label":_vm.placeHolderText},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }